<template>
  <footer class="footer" data-aos="fade">
    <div class="container">
      <div class="row">
        <div v-for="(section, index) in sections" :key="index" class="col-12 col-md-6 col-lg-4">
          <div class="box">
            <h3 class="mt-3">{{ section.footer_section_title }}</h3>
            <div class="footer-text" v-html="section.footer_section_content"></div>
          </div>
        </div>
        <div class="col-12 mt-5">
           © {{ year }} Restaurant le Komachi | <a href="http://pomzed.ch" class="pomzed-link" target="_blank">
              <svg width="100%" height="100%" viewBox="0 0 89 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g id="Textes"><path d="M65.25,9.27l0,-2.27c0,-3.41 -1.72,-4.64 -5.27,-4.69l-4.09,0c-0.014,-0.002 -0.027,-0.002 -0.041,-0.002c-0.187,0 -0.345,0.145 -0.359,0.332l0,10.92c-0.001,0.01 -0.001,0.02 -0.001,0.03c0,0.208 0.171,0.38 0.38,0.38c0,0 0.001,0 0.001,0l4.13,0c3.35,0 5.27,-1.18 5.27,-4.7l-0.02,0Zm-2.11,0c0,2.14 -0.82,3 -3.16,3l-2.4,0l0,-8.27l2.42,0c2.12,0 3.16,0.69 3.16,3l0,2.27l-0.02,0Zm-16.32,4.73l7.24,0l0,-1.75l-5.63,0l0,-3.19l4.88,0l0,-1.72l-4.88,0l0,-3.34l5.48,0l0,-1.7l-7.16,0c-0.01,-0.001 -0.02,-0.001 -0.03,-0.001c-0.208,0 -0.38,0.171 -0.38,0.38c0,0 0,0.001 0,0.001l0,10.88c-0.001,0.01 -0.001,0.02 -0.001,0.03c0,0.209 0.171,0.38 0.38,0.38c0.004,0 0.007,0 0.011,0l0.09,0.03Zm-4.61,-10l-6.21,8.41l0,1.15c-0.001,0.01 -0.001,0.02 -0.001,0.03c0,0.209 0.171,0.38 0.38,0.38c0.004,0 0.007,0 0.011,0l8.21,0c0.182,0.002 0.34,-0.13 0.37,-0.31l0,-1.1c-0.06,-0.36 -0.46,-0.31 -0.46,-0.31l-6.1,0l6.36,-8.38l0,-1.27c-0.035,-0.188 -0.21,-0.319 -0.4,-0.3l-7.51,0c-0.01,-0.001 -0.02,-0.001 -0.03,-0.001c-0.208,0 -0.38,0.171 -0.38,0.38l0,0.941c-0.001,0.01 -0.001,0.02 -0.001,0.03c0,0.196 0.155,0.36 0.351,0.37l5.41,-0.02Zm-9.61,10l2.13,0l-0.89,-11.1c-0.065,-0.349 -0.386,-0.596 -0.74,-0.57l-1.38,0c-0.283,-0.015 -0.548,0.149 -0.66,0.41l-3.06,7.36l-3,-7.42c-0.09,-0.204 -0.279,-0.348 -0.5,-0.38l-1.6,0c-0.376,-0.024 -0.708,0.256 -0.75,0.63l-0.89,11l2.15,0l0.59,-8.61l0.07,0l3,7.19l1.7,0l3.09,-7.45l0.14,0l0.6,8.94Zm-12.42,-7.19c0,-1.69 -0.14,-4.66 -5.2,-4.66c-5.06,0 -5.19,2.95 -5.19,4.65l0,2.67c0,1.69 0.12,4.65 5.19,4.65c5.07,0 5.2,-3 5.2,-4.66l0,-2.65Zm-2.1,2.65c0,2.23 -0.85,2.93 -3.1,2.93c-2,0 -3.09,-0.5 -3.09,-2.92l0,-2.67c0,-2.34 0.95,-2.93 3.09,-2.93c2.14,0 3.07,0.63 3.1,2.94l0,2.65Zm-9.54,-3.46c0,-3.26 -1.54,-3.7 -3.92,-3.7l-4.24,0c-0.199,-0.006 -0.369,0.151 -0.38,0.35l0,11.35l2.09,0l0,-4.33l2.53,0c2.38,0 3.92,-0.43 3.92,-3.67Zm-2.11,0c0,1.72 -0.68,2 -1.81,2l-2.53,0l0,-4l2.53,0c1.13,0 1.81,0.23 1.81,2Z" style="fill:#fff;fill-rule:nonzero;"/><path d="M88.15,14.54l0,-12.69c0,-0.013 0,-0.027 0,-0.04c0,-0.993 -0.817,-1.81 -1.81,-1.81c-0.013,0 -0.027,0 -0.04,0l-13.55,0c-0.013,0 -0.027,0 -0.04,0c-0.993,0 -1.81,0.817 -1.81,1.81c0,0.013 0,0.027 0,0.04l0,12.69c0,0.013 0,0.027 0,0.04c0,0.993 0.817,1.81 1.81,1.81c0.013,0 0.027,0 0.04,0l13.55,0c0.013,0 0.027,0 0.04,0c0.993,0 1.81,-0.817 1.81,-1.81c0,-0.013 0,-0.027 0,-0.04Zm-2.78,-3.89c0.001,0.027 0.001,0.054 0.001,0.081c0,1.276 -1.026,2.337 -2.301,2.379l-5.4,0l0,-2.47l3.73,0c0.777,-0.038 1.388,-0.703 1.36,-1.48l0,-2c0.022,-0.786 -0.604,-1.453 -1.39,-1.48l-5.23,0l0,7.39l-2.46,0l0,-9.8l9.38,0c1.279,0.037 2.311,1.099 2.311,2.379c0,0.024 0,0.047 -0.001,0.071l0,4.93Z" style="fill:#fff;fill-rule:nonzero;"/></g></svg>
           </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<style lang="sass" scoped>
  @import 'Bottombar';
</style>
<script>
import api from '@/api'
export default {
  data () {
    return {
      year: null,
      sections: null
    }
  },
  methods: {
    /**
     * Get footer sections data
     */
    fetchFooter () {
      this.axios.get(api.footer)
        .then(response => {
          this.sections = response.data.acf.footer_sections
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    // Set footer current year
    let currentTime = new Date()
    this.year = currentTime.getFullYear()
    // Fetch data from api
    this.fetchFooter()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Bottombar/Bottombar.vue